import { z } from 'zod';

export const customerAddressDtoSchema = z.object({
    addressId: z.string(),
    customerId: z.string(),
    street: z.string().optional(),
    city: z.string().optional(),
    country: z.string().optional(),
    countryCode: z.string().optional(),
    addressLine1: z.string().optional(),
    addressLine2: z.string().optional(),
    addressLine3: z.string().optional(),
    zipCode: z.string().optional(),

    // Do we need these?
    type: z.enum(['SHIPPING', 'BILLING', 'PRIMARY']).optional(),
});

export type CustomerAddressDTO = z.infer<typeof customerAddressDtoSchema>;
